import { aboutInfo } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              {aboutInfo.title}
            </h2>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/60">
            <div className="flex flex-wrap justify-center gap-8 md:gap-16 mb-10">
              {aboutInfo.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-3xl md:text-4xl font-extrabold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-2">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="text-sm text-foreground-600 leading-relaxed space-y-4 max-w-3xl mx-auto">
              {aboutInfo.description.split("\n\n").map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}